import { render, staticRenderFns } from "./scroll_top_button.vue?vue&type=template&id=405c4d52&scoped=true&lang=pug"
import script from "./scroll_top_button.vue?vue&type=script&lang=js"
export * from "./scroll_top_button.vue?vue&type=script&lang=js"
import style0 from "./scroll_top_button.vue?vue&type=style&index=0&id=405c4d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c4d52",
  null
  
)

export default component.exports